import { useQuery } from '@tanstack/react-query';

import { getAppConfig } from '../api/app-config.api';

export const useAppConfigInit = () => {
	const {
		data: appConfig,
		error,
		isPending,
	} = useQuery({
		queryKey: ['GET_APP_CONFIG'],
		queryFn: getAppConfig,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		enabled: true,
	});

	return {
		appConfig,
		error,
		isPending,
	};
};
